<template>
    <div>
        
    </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）

export default {
    // import引入的组件需要注入到对象中才能使用
    name: 'fromWxPage',
    components: {},
    data() {
      return {
       
      };
    },
    methods: {
        init(){
             
             let {code,state} = this.$route.query; //获取query
             console.log("code:"+code);
             console.log("state:"+state);
            //alert(code);
            //alert(state);
             //查询openid
             ///pc/wx/gzhweixinMgt/queryWxUser
            let bizData = {
                code: code, //当前页面的code
                wxAppId:state
            }             
            this.$getRequestCommon('/pc/wx/gzhweixinMgt/queryWxUser', bizData)
            .then(result =>{

                if (result.resultCode == '0000') { //不是 0000 均为失败
                    let bizDataJson = (result.bizData);
                    
                    let wxOpenId = bizDataJson.wxOpenId;
                    
                    if(!wxOpenId)
                    {
                        this.showMessage ="获取信息失败，请稍后再试";
                    }else{
                        
                        //跳转商城(保留)
                        //this.to_shop(wxOpenId,sceneStr,personName);
                        //let goUrl ="./loginPage?thirdCode="+wxOpenId+"&thirdType=wx";
                        this.$router.push({ path: '/login/loginPage', query: { thirdCode: wxOpenId, thirdType: 'wx' } })
                        //alert(goUrl);
                        //window.location.href = goUrl;

                    } 
                
                } else {
                    this.$toast.fail(result.msg);
                }

            })
            .catch(err => {
              console.log(err);
              this.$toast.fail(err);
              
            }) 
        }
    },
    computed: {},
    watch: {},
    // 生命周期 - 创建完成（可以访问当前this实例）
    created() {
        this.init();
    },
    // 生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {

    },
    // 生命周期 - 创建之前
    beforeCreate() {},
    // 生命周期 - 挂载之前
    beforeMount() {},
    // 生命周期 - 更新之前
    beforeUpdate() {},
    // 生命周期 - 更新之后
    updated() {},
    // 生命周期 - 销毁之前
    beforeDestroy() {},
    // 生命周期 - 销毁完成
    destroyed() {},
    // 如果页面有keep-alive缓存功能，这个函数会触发
    activated() {},
};
</script>

<style lang="less" scoped>
//@import url(); 引入公共css类
img {
      width: 100%;
}
</style>
